import React from 'react';
import { PresetProvider } from './preset.context';
import { PresetModal } from './PresetModal';

export const CheckoutPreset = () => {
    return (
        <PresetProvider>
            <PresetModal />
        </PresetProvider>
    );
};
